import iCheck from 'icheck';

$(function () {
  // Checkboxes
  $('input.js-minerva-form-checkbox').each(function () {
    var hasErrors = $(this).data('hasErrors');
    $(this).iCheck({
      checkboxClass: 'skinned-checkbox left border rounded inline-block',
      enabledCheckboxClass: 'enabled pointer',
      disabledCheckboxClass: 'disabled pointer-not-allowed bg-eggshell',
      uncheckedCheckboxClass: 'bg-whitest border-lightest' + (hasErrors ? ' border-red border-thicker' : ''),
      checkedCheckboxClass: 'checked bg-mid white border-darkest',
      hoverClass: 'border-darkest',
      insert: '<span>&#10003;</span>' // TODO: replace unicode with image
    });
  });
});



// WEBPACK FOOTER //
// lib/js/minerva-form/checkbox.js